//
//
//
//
//
//

    export default {
      data(){
        return {
          
        }
      },
      mounted() {
        this.checkLogin()
      },
      methods:{
       
        // 检测是否登录
        checkLogin(){
          // 用户未登录
          if(!getLocal('user')){
            this.$confirm('用户未登录,登录后解锁更多功能,是否登录?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({
                path:'/login'
              })
            })
          }
          // 用户已登录
          if(getLocal('user')){
            this.$get('/sys/user/info','',function(res){
              var info= res.data
              if(info.currentUserType==2){
              if(info.consumerAuthStatus!=1){
                this.$confirm('用户发包商身份还未认证', '提示', {
                  confirmButtonText: '去认证',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push({
                    path:'/person/renzheng'
                  })
                })
              }
            }
            if(info.currentUserType==3){
              if(info.providerAuthStatus!=1){
                this.$confirm('用户服务商身份还未认证', '提示', {
                  confirmButtonText: '去认证',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push({
                    path:'/person/renzheng'
                  })
                })
              }
            }
            })
            
          }

        }
      }

    }
